import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import CropImageContainer from './CropImageContainer'
import './../../ui.style.scss'

class CropImageModal extends Component {
    state = {
      settings: null
    }

    UNSAFE_componentWillMount (newProps) { // eslint-disable-line camelcase
      if (this.props.aspectRatio && this.props.settings) {
        const filteredSetting = { ...this.props.settings.find(setting => setting.aspectRatio === this.props.aspectRatio.aspectRatio) }
        this.setState({ settings: filteredSetting })
      }
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => { // eslint-disable-line camelcase
      if (nextProps.aspectRatio && nextProps.settings) {
        const filteredSetting = { ...nextProps.settings.find(setting => setting.aspectRatio === nextProps.aspectRatio.aspectRatio) }
        this.setState({ settings: filteredSetting })
      }
    }

    handleSubmit = () => {
      this.props.updateSettings(this.state.settings)
    }

    handleCancel = () => {
      this.setState({ settings: null })
      this.props.handleCancel()
    }

    getCropArea = (newSettings) => {
      this.setState({ settings: newSettings })
    }

    render () {
      const { imgUrl, aspectRatio, isVisible, isUpdateBlocked } = this.props
      return (
        <Modal
          className='confirm-modal edit-image'
          title='CROP IMAGE'
          maskClosable={false}
          visible={isVisible}
          okText='Crop Image'
          cancelText='Back'
          onOk={this.handleSubmit}
          onCancel={this.handleCancel}
          okButtonProps={{ disabled: isUpdateBlocked }}
          closable={false}
          centered
          width='890px'
          destroyOnClose
        >
          <CropImageContainer imgUrl={imgUrl} aspectRatio={aspectRatio} callback={this.getCropArea} settings={this.state.settings} />
        </Modal>
      )
    }
}

CropImageModal.propTypes = {
  /** Visible status of Modal. */
  isVisible: PropTypes.bool,
  /* Url  of the image */
  imgUrl: PropTypes.string,
  /** close image action callback. */
  handleCancel: PropTypes.func,
  /** Aspect ratio of the image */
  aspectRatio: PropTypes.object,
  /**  */
  updateImage: PropTypes.func,
  /**  */
  settings: PropTypes.arrayOf(PropTypes.object),
  /** Update block boolean */
  isUpdateBlocked: PropTypes.bool
}

CropImageModal.defaultProps = {
}

export default CropImageModal
